module.exports = __webpack_public_path__ + "img/record-circle.4965e0fa.svg";